import React from "react";
import { Link } from "react-router-dom";
import { Icon, Image, Container } from "semantic-ui-react";


const handlePreciseClick = () => {
    window.open('https://precise180.com/', '_blank')?.focus()
};

export const Footer = () => {
    return (<Container style={{ marginBottom: '1em', marginTop: '1em' }}>
        <span style={{ float: 'left' }}><Icon name='copyright outline' /> {new Date().getFullYear()} - Finnigan's Harp Nürnberg e.V.</span>
        <span style={{ float: 'left' , marginLeft: '150px' }}>
            Unterstützt von
            <Image
            className="centeredImage"
            src="/assets/sponsors/Precise180.jpg"
                size="medium"           
                onClick={() => handlePreciseClick()}
            centered />
        </span>
          
        <span style={{ float: 'right' }}><Link to='/impress'>Impressum</Link></span>
    </Container>)
}